import React, {useEffect, useState} from "react";
import {loginPassword, LoginPasswordCredentials, resetLoginStatus} from "../../store/reducers/AuthSlice";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {RequestStatus} from "../../utils/Enums";
import {useNavigate} from "react-router-dom";

interface LoginScreenProps {
}

export const LoginScreen: React.FC<LoginScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const authState = useAppSelector(state => state.auth);

    const requestStatus: RequestStatus = authState.loginRequestStatus;

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {

        if ( requestStatus === RequestStatus.Success ) {
            dispatch(resetLoginStatus());
            navigate('/orders');
        }

    }, [requestStatus]);

    const handlePress = () => {

        const loginCredentials:LoginPasswordCredentials = {
            username, password
        }

        dispatch(
            loginPassword(loginCredentials)
        );

    };

    return (
        <>
            <div id="ribbon-login">
            </div>

            <div id="login-wrap">
                <div className="form">
                    <h2><span>Kasutaja tuvastamine</span></h2>
                    <form method="post" name="login_form"   action="">
                        <table className="form">
                            <tbody>
                            <tr>
                                <th><label htmlFor="username">Kasutajanimi:</label></th>
                                <td>
                                    <input
                                        id="username"
                                        name="username"
                                        type="text"
                                        className="text"
                                        value={username} // Bind the input value to the state variable
                                        onChange={(e) => setUsername(e.target.value)} // Update the username state
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><label htmlFor="password">Parool:</label></th>
                                <td>
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        className="text"
                                        value={password} // Bind the input value to the state variable
                                        onChange={(e) => setPassword(e.target.value)} // Update the password state
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </form>
                    <p className="actions">
                        <button type="button" className="fl-r" onClick={handlePress}><span><strong>Logi sisse</strong></span></button>
                    </p>
                </div>
            </div>
        </>
    )
}